import '../GerenciamentoTurmas/GerenciamentoTurmas.css'
import React, { useState, useEffect } from 'react';
import { FormGroup, Table, Button, Label, Tooltip, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { PlusCircleFill, ArrowLeftCircleFill, Search, DashCircleFill } from 'react-bootstrap-icons';
import axios from 'axios';



const CadastroMotorista = ({ token, deParaUnidades}) => {
    const [importarEmpresa, setImportarEmpresa] = useState(false);
    const [cadastroEmpresa, setCadastroEmpresa] = useState(false);
    const [cadastroAuxiliar, setCadastroAuxiliar] = useState(false);
    const [listaAuxiliares, setListaAuxiliares] = useState([]);
    const [listaEmpresas, setListaEmpresas] = useState(null);
    const [cpfCnpjEmpresa, setCpfCnpjEmpresa] = useState();
    const [nomeEmpresaMain, setNomeEmpresaMain] = useState();
    const [uuidEmpresaMain, setUuidEmpresaMain] = useState();
    const [empresaTooltip, setEmpresaTooltip] = useState(false);
    const [auxiliarTooltip, setAuxiliarTooltip] = useState(false);
    const [empresaNomePesquisa, setEmpresaNomePesquisa] = useState();
    const [empresaCnpjPesquisa, setEmpresaCnpjPesquisa] = useState();
    const [empresaNomeCadastro, setEmpresaNomeCadastro] = useState();
    const [empresaCnpjCadastro, setEmpresaCnpjCadastro] = useState();
    const [auxiliarNomeImportar, setAuxiliarNomeImportar] = useState();
    const [auxiliarCpfImportar, setAuxiliarCpfImportar] = useState();
    const [nomeMotoristaMain, setNomeMotoristaMain] = useState();
    const [cpfMotoristaMain, setCpfMotoristaMain] = useState();
    const [listaCdAlunos, setListaCdAlunos] = useState();
    const [listaAlunosPesquisa, setListaAlunosPesquisa] = useState([]);
    const [importarAluno, setImportarAluno] = useState(false);
    const [alunoTooltip, setAlunoTooltip] = useState(false);
    const [nomeAlunoPesquisa, setNomeAlunoPesquisa] = useState(null);
    const [listaAlunos, setListaAlunos] = useState([])
    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const toogleImportarAluno = () => {
        setImportarAluno(!importarAluno);
    }
    const toogleAlunoTooltip = () => {
        setAlunoTooltip(!alunoTooltip);
    }

    const toogleEmpresaTooltip = () => {
        setEmpresaTooltip(!empresaTooltip);
    }

    const toogleAuxiliarTooltip = () => {
        setAuxiliarTooltip(!auxiliarTooltip);
    }

    const toogleCadastroAuxiliar = () => {
        if (cpfCnpjEmpresa) {
            setCadastroAuxiliar(!cadastroAuxiliar);
        } else {
            alert('Por favor, preencher as informações da empresa.');
        }
    }

    const handleApagarAluno = (alunoToRemove) => {
        setListaAlunos(listaAlunos.filter(aluno => aluno.cdAluno !== alunoToRemove.cdAluno));
    }

    const handleApagarAuxiliar = (auxiliarToRemove) => {
        setListaAuxiliares(listaAuxiliares.filter(auxiliar => auxiliar !== auxiliarToRemove));
    }

    const toogleImportarEmpresa = () => {
        setImportarEmpresa(!importarEmpresa);
    }

    const toogleCadastroEmpresa = () => {
        setCadastroEmpresa(!cadastroEmpresa);
    }
    const handleAbrirCadastroEmpresa = () => {
        toogleImportarEmpresa();
        toogleCadastroEmpresa();
    }

    const handleSelecaoAluno = (aluno) => {
        listaAlunos.push(aluno);
        toogleImportarAluno();
    }

    const handleCadastrarEmpresa = async () => {
        let nome = empresaNomeCadastro;
        let cnpj = empresaCnpjCadastro;
        const response = await axios.post("cadastroEmpresa/cadastrar/", {
            nome, cnpj
        },
            {
                auth: {
                    username,
                    password
                }
            });
        if (response.data) {
            handleBuscarEmpresa();
            toogleCadastroEmpresa();
            toogleImportarEmpresa();
        }
        
    }

    const handleBuscarEmpresa = async () => {
        let nome = empresaNomePesquisa;
        let cnpj = empresaCnpjPesquisa;
        const response = await axios.post("cadastroEmpresa/buscarEmpresa/", {
            nome, cnpj
        },
            {
                auth: {
                    username,
                    password
                }
            });
        setListaEmpresas(response.data);
    }

    const handleSelecaoEmpresa = (empresa) => {
        setCpfCnpjEmpresa(empresa.cnpj);
        setNomeEmpresaMain(empresa.nome);
        setUuidEmpresaMain(empresa.uuid);
        toogleImportarEmpresa();
    }

    const handleImportarAuxiliar = () => {
        let nome = auxiliarNomeImportar;
        let cpf = auxiliarCpfImportar;
        let uuidEmpresa = null;
        let motoristasAssociados = null;
        let codigosAlunosAssociado = null;
        listaAuxiliares.push({ nome, cpf, uuidEmpresa, motoristasAssociados, codigosAlunosAssociado });
        setAuxiliarCpfImportar(null);
        setAuxiliarNomeImportar(null);
        toogleCadastroAuxiliar();
    }

    const handleCadastrarMotorista = async () => {
        let nome = nomeMotoristaMain;
        let cpf = cpfMotoristaMain;
        let uuidEmpresa = uuidEmpresaMain;
        let motoristasAssociados = listaAuxiliares;
        let codigosAlunosAssociado = gerarListaCodigosAlunos();
        let unidade = token.usuario.departamento.id.codfilial;
        const response = await axios.post("motorista/cadastro/", {
           nome, cpf, uuidEmpresa, unidade, motoristasAssociados, codigosAlunosAssociado
        },
            {
                auth: {
                    username,
                    password
                }
            });
        window.location.reload();
        alert('Cadastro Enviado.')
    }

    const gerarListaCodigosAlunos = () => {
        console.log(listaAlunos);
        let novaListaCodigos = listaAlunos.map(aluno => aluno.cdAluno)
        return novaListaCodigos;
    }

    const handleBuscarAluno = async () => {
        let cdUnidadeDb2 = token.usuario.departamento.id.codfilial;
        let cdUnidadeSophia = deParaUnidades[cdUnidadeDb2];
        const response = await axios.post("aluno/pesquisa/porNome/" + nomeAlunoPesquisa, {
            cdUnidadeSophia
        },
            {
                auth: {
                    username,
                    password
                }
            });
        setListaAlunosPesquisa(response.data);
    }

    const handleCpfCnpjChange = (event) => {
        // Get only the numbers from the data input
        let data = event.target.value.replace(/\D/g, "");
        // Checking data length to define if it is cpf or cnpj
        if (data.length > 11) {
            // It's cnpj
            let cnpj = `${data.substr(0, 2)}.${data.substr(2, 3)}.${data.substr(5, 3)}/`;
            if (data.length > 12)
                cnpj += `${data.substr(8, 4)}-${data.substr(12, 2)}`;
            else
                cnpj += data.substr(8);
            // Pass formatting for the data
            data = cnpj;
        } else {
            // It's cpf
            let cpf = "";
            let parts = Math.ceil(data.length / 3);
            for (let i = 0; i < parts; i++) {
                if (i === 3) {
                    cpf += `-${data.substr(i * 3)}`;
                    break;
                }
                cpf += `${i !== 0 ? "." : ""}${data.substr(i * 3, 3)}`;
            }
            // Pass formatting for the data
            data = cpf;
        }
        return data;
    };

    const renderlistaAuxiliares = () => {
        let renderedList = [];
        for (let auxiliar of listaAuxiliares) {
            renderedList.push(renderAuxiliarSingle(auxiliar));
        }
        return renderedList;
    }

    const renderAuxiliarSingle = (auxiliar) => {
        return (
            <div className="cadastroMotoristaSubtitles" >
                <h8 className="tabelaComponent" >
                    {"Nome: " + auxiliar["nome"] + " (CPF: " + auxiliar["cpf"] + ") "}
                </h8>
                <DashCircleFill size="30" onClick={() => handleApagarAuxiliar(auxiliar)} />
            </div>
        );
    }

    const renderlistaEmpresas = () => {
        let renderedList = [];
        for (let empresa of listaEmpresas) {
            renderedList.push(renderEmpresaSingle(empresa));
        }
        return renderedList;
    }

    const renderEmpresaSingle = (empresa) => {
        return (
            <div className="tabelaItem" onClick={() => handleSelecaoEmpresa(empresa)}>
                <h8 className="tabelaComponent">
                    {"Nome: " + empresa["nome"] + " (CNPJ: " + empresa["cnpj"] + ") "}
                </h8>
            </div>
        );
    }

    const renderlistaAlunosPesquisa = () => {
        let renderedList = [];
        for (let aluno of listaAlunosPesquisa) {
            renderedList.push(renderAlunoSinglePesquisa(aluno));
        }
        return renderedList;
    }

    const renderAlunoSinglePesquisa = (aluno) => {
        return (
            <div className="tabelaItem" onClick={() => handleSelecaoAluno(aluno)}>
                <h8 className="tabelaComponent">
                    {aluno["nome"] + " (Turma: " + aluno["nomeTurma"] + ") "}
                </h8>
            </div>
        );
    }

    const renderlistaAlunos = () => {
        let renderedList = [];
        for (let aluno of listaAlunos) {
            renderedList.push(renderAlunoSingle(aluno));
        }
        return renderedList;
    }

    const renderAlunoSingle = (aluno) => {
        return (
            <div className="cadastroMotoristaSubtitles">
                <h8 className="tabelaComponent">
                    {aluno["nome"] + " (Turma: " + aluno["nomeTurma"] + ") "}
                </h8>
                <DashCircleFill size="30" onClick={() => handleApagarAluno(aluno)} />
            </div>
        );
    }

    return (
        <>
            <>
                <h2 className="titulosPaginas">Cadastro de Motorista</h2>
                <div className="TabelaConfig">
                    <div className="cadastroMotoristaSubtitles">
                        <h6 className="titulosTabelas">
                            DADOS MOTORISTA
                        </h6>
                    </div>
                    <FormGroup>
                        <div className="cadastroMotoristaSubtitlesModal">
                        <div>
                        <Label> Nome </Label>
                        <input type="text" placeholder="Nome Motorista" onChange={(e) => setNomeMotoristaMain(e.target.value)}
                                className="entradaCadastroMotoristas" />
                        </div>
                        <div>
                        <Label> CPF </Label>
                        <input type="text" placeholder="CPF Motorista" value={cpfMotoristaMain} className="entradaCadastroMotoristas"
                                onChange={(e) => setCpfMotoristaMain(handleCpfCnpjChange(e))} />
                            </div>
                            </div>
                    </FormGroup>
                    <div className="cadastroMotoristaSubtitles">
                        <h6 className="titulosTabelas">
                            DADOS EMPRESA
                        </h6>
                            <PlusCircleFill id="importarEmpresa" size="30" onClick={() => toogleImportarEmpresa()} />
                            <Tooltip
                                isOpen={empresaTooltip}
                                target="importarEmpresa"
                                toggle={toogleEmpresaTooltip}
                            >
                                Importar Empresa
                            </Tooltip>
                    </div>
                    <FormGroup>
                        <div className="cadastroMotoristaSubtitlesModal">
                        <div>
                        <Label> Nome </Label>
                            <input type="text" placeholder="-----" value={nomeEmpresaMain} className="entradaCadastroMotoristas" disabled />
                        </div>
                        <div>
                        <Label> CNPJ </Label>
                            <input type="text" placeholder="-----" value={cpfCnpjEmpresa} className="entradaCadastroMotoristas" disabled />
                            </div>
                        </div>
                    </FormGroup>
                    <hr />
                    <div className="cadastroMotoristaSubtitles">
                        <h6 className="titulosTabelas">
                            ALUNOS
                        </h6>
                            <PlusCircleFill id="adicionarAluno" size="30" onClick={() => toogleImportarAluno()} />
                            <Tooltip
                                isOpen={alunoTooltip}
                                target="adicionarAluno"
                                toggle={toogleAlunoTooltip}
                            >
                                Adicionar Aluno
                            </Tooltip>
                    </div>
                    {listaAlunos === null ? (<tr> <td> none </td></tr>) : renderlistaAlunos()}
                    <hr />
                    <div className="cadastroMotoristaSubtitles">
                        <h6 className="titulosTabelas">
                            AUXILIARES
                        </h6>
                            <PlusCircleFill id="adicionarAuxiliar" size="30" onClick={() => toogleCadastroAuxiliar()} />
                            <Tooltip
                                isOpen={auxiliarTooltip}
                                target="adicionarAuxiliar"
                                toggle={toogleAuxiliarTooltip}
                            >
                                Adicinar Auxiliar
                            </Tooltip>
                    </div>
                    {listaAuxiliares === null ? (<tr> <td> none </td></tr>) : renderlistaAuxiliares()}
                </div>
                <Button onClick={() => handleCadastrarMotorista()}>
                    Cadastrar
                </Button>
            </>
            <Modal isOpen={importarAluno} toggle={toogleImportarAluno}>
                <ModalHeader className="TabelaGer" toggle={toogleImportarAluno}>
                    <h4>Pesquisa Aluno</h4>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <>
                        <div className="cadastroMotoristaSubtitlesModal">
                            <input type="text" placeholder="Buscar por Nome Aluno" className="inputMotoristaModal"
                            onChange={(e) => setNomeAlunoPesquisa(e.target.value)} />
                        <Button className="searchDataButton" onClick={() => handleBuscarAluno()}>
                            <Search />
                            </Button>
                        </div>
                        <div className="importarEmpresa">
                            <h2 className="titulosPaginas">Alunos</h2>
                            </div>
                        {listaAlunosPesquisa === null ? (<tr> <td> none </td></tr>) : renderlistaAlunosPesquisa()}
                    </>
                </ModalBody>
            </Modal>
            <Modal isOpen={cadastroEmpresa} toggle={toogleCadastroEmpresa}>
                <ModalHeader className="TabelaGer" toggle={toogleCadastroEmpresa}>
                    <h4>Cadastro de Empresa</h4>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <>
                        <FormGroup>
                            <div className="cadastroMotoristaSubtitlesModal">
                                <Label> Nome </Label>
                                <input type="text" placeholder="Preencher" className="pesquisaRapidaTurmas"
                                    onChange={(e) => setEmpresaNomeCadastro(e.target.value)} />
                                <Label> CNPJ </Label>
                                <input type="text" placeholder="Preencher" value={empresaCnpjCadastro} className="pesquisaRapidaTurmas"
                                    onChange={(e) => setEmpresaCnpjCadastro(handleCpfCnpjChange(e))} />
                                <hr />
                            </div>
                        </FormGroup>
                        <div className="importarEmpresa">
                        <Button className="submitRegistrosButton" onClick={() => handleCadastrarEmpresa()}>
                            Cadastrar
                            </Button>
                            </div>
                    </>
                </ModalBody>
            </Modal>
            <Modal isOpen={importarEmpresa} toggle={toogleImportarEmpresa}>
                <ModalHeader className="TabelaGer" toggle={toogleImportarEmpresa}>
                    <div className="cadastroMotoristaSubtitlesModal">
                        <h4 style={{ marginRight:"1rem" }}>Pesquisa Empresa</h4>
                        <Button className="submitRegistrosButton" onClick={() => handleAbrirCadastroEmpresa()}>
                            Cadastrar Empresa <PlusCircleFill size="40" />
                        </Button>
                    </div>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <>
                        <div className="cadastroMotoristaSubtitlesModal">
                            <input type="text" placeholder="Buscar por Nome Empresa" className="inputMotoristaModal"
                            onChange={(e) => setEmpresaNomePesquisa(e.target.value)} />
                        <Button className="searchDataButton" onClick={() => handleBuscarEmpresa()}>
                            <Search />
                            </Button>
                        </div>
                       
                        <div className="importarEmpresa">
                            <h2 className="titulosPaginas">Empresas</h2>
                        </div>
                        {listaEmpresas === null ? (<tr> <td> none </td></tr>) : renderlistaEmpresas()}
                    </>
                </ModalBody>
            </Modal>
            <Modal isOpen={cadastroAuxiliar} toggle={toogleCadastroAuxiliar}>
                <ModalHeader className="TabelaGer" toggle={toogleCadastroAuxiliar}>
                    <h4>CADASTRO DE AUXILIAR</h4>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <>
                        <FormGroup>
                            <div className="cadastroMotoristaSubtitlesModal">
                                <div>
                                <Label> Nome </Label>
                                    <input type="text" placeholder="Preencher" className="inputMotoristaModal"
                                        onChange={(e) => setAuxiliarNomeImportar(e.target.value)} />
                                </div>
                                <div>
                                <Label> CPF </Label>
                                <input type="text" placeholder="Preencher" value={auxiliarCpfImportar}
                                        className="inputMotoristaModal"
                                        onChange={(e) => setAuxiliarCpfImportar(handleCpfCnpjChange(e))} />
                                    </div>
                            </div>
                        </FormGroup>
                        <div className="importarEmpresa">
                            <Button className="submitRegistrosButton" onClick={() => handleImportarAuxiliar()}>
                            Cadastrar
                            </Button>
                            </div>
                    </>
                </ModalBody>
            </Modal>
        </>
    );
}

export default CadastroMotorista;